import { FormsEnum, SectionsEnum } from 'app/shared/enums';
// prettier-ignore
import { setHistoryVisibilityBasedOnPersonalData } from 'app/services/businessFunctions/helpers/setHistoryVisibilityBasedOnPersonalData';

const historyVisibilityBasedOnPersonalData = {
  setFirstCoownerHistoryVisibilityBasedOnPersonalData() {
    setHistoryVisibilityBasedOnPersonalData({
      insuranceHistorySection: SectionsEnum.Coowners1InsuranceHistory,
      formName: FormsEnum.CalculationForm,
    });
  },
};

export default historyVisibilityBasedOnPersonalData;
